<template>
  <div class="school-detail-lite">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/postgraduate' }">研招</el-breadcrumb-item>
      <el-breadcrumb-item>学校详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="school-hero">
      <div class="hero-inner">
        <div class="school-base">
          <div style="display: flex;align-items: center;">
            <h1 class="school-name">{{ school.name }}</h1>
          <div style="display: flex;align-items: center;margin-left: 20px;">
            <img src="../../assets/images/wz.png" alt="位置" style="color: #fff;">
            {{ school.city }}
          </div>
          </div>
          <div class="school-meta">
            <!-- <span class="meta-item">
              <i class="el-icon-location-outline"></i>
              所在地：{{ school.city }}
            </span> -->
            <span class="meta-item">主管部门：{{ school.dept }}</span>
          </div>

          <div class="school-tags">
            <span
              v-for="(tag, index) in school.tags"
              :key="index"
              class="school-tag"
            >
              {{ tag }}
            </span>
          </div>

         <!-- <el-button type="warning" class="consult-btn">在线咨询</el-button>-->
        </div>
      </div>
      <ul class="change-list">
        <li
        v-for="item in navList"
          :key="item.key"
          @click="activeNav = item.key"
          :class="{'active': activeNav === item.key}"
        >
        {{ item.label }}
        </li>
      </ul>
    </div>

    <div class="page-main">
      <div class="section-title" v-if="false">
        <span></span>
        <h2>院校概况</h2>
        <span></span>
      </div>

      <div class="card-nav" v-if="false">
        <div
          v-for="item in navList"
          :key="item.key"
          :class="['nav-card', { active: activeNav === item.key }]"
          @click="activeNav = item.key"
        >
          <i :class="item.icon"></i>
          <p>{{ item.label }}</p>
        </div>
      </div>

      <template v-if="activeNav === 'info'">
        <div class="section-title recruit-title" v-if="false">
          <span></span>
          <h2>招生信息</h2>
          <span></span>
        </div>

        <el-row :gutter="24" class="content-row">
          <el-col :span="24">
            <div class="info-panel">
              <div class="panel-header">
                <h3>招生简章</h3>
              </div>
              <div class="panel-body" v-if="brochureList.length">
                <div v-for="item in brochureList" :key="'brochure-' + item.id" class="info-item" @click="handleGoDetails(item)">
                  <span class="info-title">{{ item.title }}</span>
                  <span class="info-date">{{ item.date }}</span>
                </div>
              </div>
              <div class="empty-box" v-else>暂无数据</div>
            </div>

            <div class="info-panel">
              <div class="panel-header">
                <h3>信息公告</h3>
              </div>
              <div class="panel-body" v-if="noticeList.length">
                <div v-for="item in noticeList" :key="'notice-' + item.id" class="info-item" @click="handleGoDetails(item)">
                  <span class="info-title">{{ item.title }}</span>
                  <span class="info-date">{{ item.date }}</span>
                </div>
              </div>
              <div class="empty-box" v-else>暂无数据</div>
            </div>

            <div class="info-panel">
              <div class="panel-header">
                <h3>网报公告</h3>
              </div>
              <div class="panel-body" v-if="netReportList.length">
                <div v-for="item in netReportList" :key="'net-' + item.id" class="info-item" @click="handleGoDetails(item)">
                  <span class="info-title">{{ item.title }}</span>
                  <span class="info-date">{{ item.date }}</span>
                </div>
              </div>
              <div class="empty-box" v-else>暂无数据</div>
            </div>

            <div class="info-panel">
              <div class="panel-header">
                <h3>调剂方法</h3>
              </div>
              <div class="panel-body" v-if="transferList.length">
                <div v-for="item in transferList" :key="'transfer-' + item.id" class="info-item" @click="handleGoDetails(item)">
                  <span class="info-title">{{ item.title }}</span>
                  <span class="info-date">{{ item.date }}</span>
                </div>
              </div>
              <div class="empty-box" v-else>暂无数据</div>
            </div>
          </el-col>
          <!-- <el-col :span="8">
            <div class="side-banner purple" @click="handleGoMajor"></div>
          </el-col> -->
        </el-row>
      </template>

 <template v-else-if="activeNav === 'major'">
  <div class="major-section">
    <div class="major-title" v-if="false">专业介绍</div>

    <div class="major-panel">
      <div class="panel-header">
        <h3>硕士专业</h3>
      </div>

      <template v-if="majorCateList.length">
        <div class="major-tabs">
          <div
            v-for="item in majorCateList"
            :key="item"
            :class="['major-tab', { active: activeMajorCategory === item }]"
            @click="handleMajorCategoryChange(item)"
          >
            {{ item }}
          </div>
        </div>

        <div class="major-grid" v-if="majorList.length">
          <div
            v-for="item in majorList"
            :key="item.id"
            class="major-item"
          >
            {{ item.special_name }}
          </div>
        </div>

        <div class="empty-box" v-else>暂无数据</div>
      </template>

      <div class="empty-box" v-else>暂无数据</div>
    </div>
  </div>
</template>
<template v-else-if="activeNav === 'majorDirectory'">
  <MasterMajorCatalog />
</template>
    </div>
  </div>
</template>

<script>
import {
  getSchoolDetailssAPI,
  getSchoolDetailAPI,
  getSchoolNetReportAPI,
  getSchoolListsAPI,
  getSchoolMajorAPI
} from "@/api/postgraduate.js"
import MasterMajorCatalog from "@/views/postgraduate/MasterMajorCatalog.vue"
export default {
  name: "SchoolDetailLite",
  components: {
    MasterMajorCatalog
  },
  data() {
    return {
      activeNav: "info",
      schoolRouteId: "",
      schoolId: "",
      school: {
        name: "",
        city: "",
        dept: "",
        tags: []
      },
      navList: [
        { key: "info", label: "招生信息", icon: "el-icon-menu" },
        { key: "major", label: "专业介绍", icon: "el-icon-notebook-2" },
        { key: "majorDirectory", label: "开设专业", icon: "el-icon-notebook-2" }
      ],
      brochureList: [],
      noticeList: [],
      netReportList: [],
      transferList: [],
      majorCateList: [],
      majorList: [],
      activeMajorCategory: ""
    }
  },
  created() {
    this.schoolRouteId = this.$route.query.scl_id || this.$route.params.scl_id || ""
    if (this.schoolRouteId) {
      this.getSchoolBaseHandler()
    }
  },
  methods: {
    handleGoMajor(){
      this.$router.push({
        path: "/mastermaca",
        query: {
          scl_id: this.schoolRouteId
        }
      })
    },
    handleGoDetails(item){
      // console.log(item)
      this.$router.push({
      path: "/pgdetail",
      query: {
        id: item.id,
        scl_id: this.schoolRouteId,
        // type: '1'
      }
    })
    },
    formatDate(value) {
      if (!value) return ""
      return String(value).slice(0, 10)
    },

    buildTags(detail) {
      const tags = []
      if (Number(detail.is_syl) === 1) tags.push("双一流建设高校")
      if (Number(detail.is_yjsy) === 1) tags.push("研究生院")
      if (Number(detail.is_zhx) === 1) tags.push("自划线")
      return tags
    },

    getSchoolBaseHandler() {
      getSchoolDetailssAPI(this.schoolRouteId).then(res => {
        const data = res.data || {}

        this.schoolId = data.id || ""
        this.school = {
          name: data.scl_name || "",
          city: data.scl_city ? (String(data.scl_city).includes("市") ? data.scl_city : data.scl_city + "市") : "",
          dept: data.scl_dept || "",
          tags: this.buildTags(data)
        }

        if (this.schoolId) {
          this.getRecruitInfoHandler()
          this.getMajorCateHandler()
        }
      })
    },

    getRecruitInfoHandler() {
      Promise.all([
        getSchoolDetailAPI(this.schoolId, 1),
        getSchoolDetailAPI(this.schoolId, 2),
        getSchoolDetailAPI(this.schoolId, 3),
        getSchoolNetReportAPI(this.schoolId)
      ]).then(([brochureRes, noticeRes, transferRes, netRes]) => {
        const brochureData = brochureRes.data.data || []
        const noticeData = noticeRes.data.data || []
        const transferData = transferRes.data.data || []
        const netData = netRes.data.data || []

        this.brochureList = brochureData.map(item => ({
          id: item.id,
          title: item.news_title,
          date: this.formatDate(item.create_time)
        }))

        this.noticeList = noticeData.map(item => ({
          id: item.id,
          title: item.news_title,
          date: this.formatDate(item.create_time)
        }))

        this.transferList = transferData.map(item => ({
          id: item.id,
          title: item.news_title,
          date: this.formatDate(item.create_time)
        }))

        this.netReportList = netData.map(item => ({
          id: item.id,
          title: item.notice_title,
          date: this.formatDate(item.create_time)
        }))
      })
    },

    getMajorCateHandler() {
      getSchoolListsAPI(this.schoolId).then(res => {
        const list = res.data || []
        this.majorCateList = Array.isArray(list) ? list : []
        this.activeMajorCategory = this.majorCateList[0] || ""

        if (this.activeMajorCategory) {
          this.getMajorListHandler(this.activeMajorCategory)
        } else {
          this.majorList = []
        }
      })
    },

    getMajorListHandler(cateName) {
      getSchoolMajorAPI(this.schoolId, cateName).then(res => {
        const list = res.data.data || []
        this.majorList = Array.isArray(list) ? list : []
      })
    },

    handleMajorCategoryChange(item) {
      if (this.activeMajorCategory === item) return
      this.activeMajorCategory = item
      this.getMajorListHandler(item)
    }
  }
}
</script>


<style lang="scss" scoped>
.school-detail-lite {
  min-height: 100vh;
  background: #f5f7fb;
}

.breadcrumb-box {
  width: 1200px;
  margin: 16px auto 0;
}

.school-hero {
  // margin-top: 16px;
  // background: linear-gradient(135deg, #2789db, #4aa5f2);
  // padding: 30px 0 36px;
  width: 1200px;
  margin: 0 auto;
  padding: 32px 40px 0 40px;
  border-radius: 20px;
  margin-top: 24px;
  background: url('../../assets/images/schoolDetail.jpg') no-repeat center center;
  background-size: cover;
  box-sizing: border-box;
}
.change-list{
  display: flex;
  // justify-content: center;
  gap: 32px;
  padding-left: 0;
  list-style: none; 
}
.change-list li{
  font-size: 16px;
  height: 50px;
  line-height: 50px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}
.change-list li.active{
  color: #fff;
    border-bottom: 3px solid #fff;
  box-sizing: border-box;
}

.hero-inner {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.school-base {
  color: #fff;
}

.school-name {
  margin: 0 0 16px;
  font-size: 42px;
  font-weight: 700;
}

.school-meta {
  margin-bottom: 16px;
  font-size: 16px;
}

.meta-item {
  margin-right: 24px;
}

.school-tags {
  margin-bottom: 18px;
}

.school-tag {
  margin-right: 10px;
  // border-color: rgba(255, 255, 255, 0.2);
  padding: 3px 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}

.consult-btn {
  padding: 12px 28px;
  font-size: 16px;
  font-weight: 600;
}

.page-main {
  width: 1200px;
  margin: 0 auto;
  // padding: 42px 0 60px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
}

.section-title span {
  width: 160px;
  height: 1px;
  background: #cfe3f8;
}

.section-title h2 {
  margin: 0 18px;
  font-size: 22px;
  color: #1f2d3d;
  font-weight: 700;
}

.card-nav {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-bottom: 44px;
}

.nav-card {
  width: 180px;
  height: 120px;
  background: #fff;
  border-top: 4px solid #2b87db;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nav-card i {
  font-size: 28px;
  color: #2b87db;
  margin-bottom: 14px;
}

.nav-card p {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.nav-card.active {
  box-shadow: 0 8px 24px rgba(43, 135, 219, 0.12);
  transform: translateY(-2px);
}

.recruit-title {
  margin-top: 8px;
}

.content-row {
  margin-top: 20px;
}

.info-panel,
.major-panel {
  background: #fff;
  border-radius: 8px;
  padding: 0 24px 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.04);
}

.panel-header {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1f2d3d;
  padding-left: 12px;
  position: relative;
}

.panel-header h3::before {
  content: "";
  width: 4px;
  height: 20px;
  background: #2b87db;
  position: absolute;
  left: 0;
  top: 2px;
  border-radius: 2px;
}

.panel-body {
  background: #f8f9fb;
  border-radius: 6px;
  padding: 6px 16px;
}

.info-item {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  font-size: 15px;
  cursor: pointer;
}

.info-title {
  flex: 1;
  padding-right: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-date {
  color: #999;
  flex-shrink: 0;
}

.empty-box {
  background: #f8f9fb;
  border-radius: 6px;
  padding: 28px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.major-section {
  margin-top: 12px;
}

.major-title {
  font-size: 38px;
  font-weight: 700;
  color: #1f2d3d;
  margin-bottom: 24px;
}

.major-tabs {
  display: flex;
  align-items: center;
  gap: 20px;
  border-top: 1px solid #eef1f5;
  padding: 18px 0 0;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.major-tab {
  padding: 0 2px 10px;
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.major-tab.active {
  color: #2b87db;
  border-bottom-color: #2b87db;
}

.major-grid {
  background: #f8f9fb;
  border-radius: 6px;
  padding: 8px 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 24px;
}

.major-item {
  height: 54px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #1f2d3d;
  // border-bottom: 1px solid #eef1f5;
}

.major-item:nth-last-child(-n + 3) {
  border-bottom: none;
}
.side-banner {
  height: 87px;
  border-radius: 8px;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
  cursor: pointer;
}

.side-banner.purple {
  background: url('https://t2.chei.com.cn/yz/assets/images/sch/ssml.jpg');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  // background: linear-gradient(135deg, #8f59ff, #b783ff);
}
</style>
